module.exports = __webpack_public_path__ + "img/onBoardIcon.2ca46406.png";